import { render, staticRenderFns } from "./TrayConfigStep.component.vue?vue&type=template&id=1296c792&scoped=true"
import script from "./TrayConfigStep.component.vue?vue&type=script&lang=js"
export * from "./TrayConfigStep.component.vue?vue&type=script&lang=js"
import style0 from "./TrayConfigStep.component.vue?vue&type=style&index=0&id=1296c792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296c792",
  null
  
)

export default component.exports